import React from "react";

// components
import { Link } from "react-router-dom";
import { Button } from "../_commons/Button";
import { SelectFilter } from "../_commons/SelectFilter";
import { SearchFilter } from "../_commons/SearchFilter";

// assets
import CreateIcon from "../_commons/CreateIcon";
import BulkActionIcon from "../_commons/BulkActionIcon";
import HelpIcon from "../_commons/HelpIcon";
import TableColumnSelector from "../_commons/TableColumnSelector";
import { extractInitials } from "../../atlas-utils";
import { SelectFilterCustom } from "../_commons/SelectFilterCustom";

export const Header = (props) => {
	const handleBrandsLabelOption = (brand) => {
		return (
			<React.Fragment>
				<div className={"logo " + brand.color}>
					{brand.image ? <img src={brand.image} alt="" /> : extractInitials(brand?.name?.split(" "))}
				</div>
				<div title={brand.name}>
					{brand.name && brand.name.length > 25 ? brand.name.slice(0, 25) + "..." : brand.name}
				</div>
			</React.Fragment>
		);
	};

	return (
		<React.Fragment>
			<div className="credits-section-header transactions-list-header">
				<div className="header-text">
					<div className="title">Items</div>
					<div className="subtitle">Central repository for all your items</div>
				</div>
				{!props.hideHeaderSectionRight && (
					<div className="header-action-button">
						<div className="filter-buttons">
							{/* {
							props.dimensions.width > 768 &&
							<div className={(props.filterActive ? "active":"")+" filter-in-header campaign-list-filter"}>
								<div className="container" onClick={props.flipShowFilters}>
									<img className="filter-icon" src="/assets/icons/icon-sorting-options.svg" alt=""/>
									<div className="filter-title">
										Filter
										{
											props.filterCount > 0 &&
											<span className="filter-count">{props.filterCount}</span>
										}
									</div>
								</div>
							</div>
						} */}
							{props.isCatalogueManagement && (
								<div className="bulk-actions-container">
									<Link to="/bulk/items">
										<Button type="secondary">
											<BulkActionIcon />
											<span>Bulk Actions</span>
										</Button>
									</Link>
								</div>
							)}
							{props.isCatalogueManagement && (
								<div className="action-buttons-container">
									<Link to="/items/new">
										<Button>
											<CreateIcon />
											<span>Create New</span>
										</Button>
									</Link>
								</div>
							)}
							{
								props.searchKeywords.length > 1 && props.dimensions.width > 768 && (
									<div className="search-input-container">
										<SelectFilter
											options={props.searchKeywords}
											field="searchFieldSelected"
											currValue={props.searchFieldSelected}
											setFilter={props.handleSearchField}
											labelKey="valueForDisplay"
											valueKey="key"
											isSearchable={false}
											isClearable={false}
										/>
										<SearchFilter
											filterOption={{ field: "searchFieldValue" }}
											value={props.searchFieldValue}
											setFilter={props.setFilter}
											placeholder="Search"
										/>
									</div>
								)
								// :
								// props.dimensions.width > 768 && null
								// <SearchFilter
								// 	filterOption={{ field: 'searchFieldValue' }}
								// 	value={props.searchFieldValue}
								// 	setFilter={props.setFilter}
								// 	placeholder="Search"
								// />
							}
							<div className="help-btn-container">
								<Button clickHandler={props.handlePiperAcademy} type="secondary">
									<HelpIcon />
									<span>Help</span>
								</Button>
							</div>
						</div>
					</div>
				)}
			</div>
			<div className="filters-second-section">
				<div className="section-1">
					{props.isMultibrandEnabled && (
						<SelectFilterCustom
							options={props.brands.items}
							isLoading={props.brands.isLoading}
							field="brands"
							currValue={props.selectedBrand}
							setFilter={(f, value) => props.handleBrand(value)}
							labelKey="name"
							valueKey="id"
							isSearchable={false}
							customLabel={true}
							customOptions={true}
							isClearable={true}
							renderLabel={handleBrandsLabelOption}
							renderOptions={handleBrandsLabelOption}
							placeholder="Select brand"
						/>
					)}
					<SelectFilter
						placeholder="Category"
						options={props.categoryFilter?.[0]?.values}
						labelKey="valueForDisplay"
						valueKey="value"
						field="item_discrete_category_id"
						setFilter={props.setFilter}
					/>
					{/* <div className={(props.filterActive ? "active":"")+" filter-in-header"}>
					<div className="container" onClick={props.flipShowFilters}>
						<img className="filter-icon" src="/assets/icons/icon-sorting-options.svg" alt=""/>
						<div className="filter-title">
							Filter
							{
								props.filterCount > 0 &&
								<span className="filter-count">{props.filterCount}</span>
							}
						</div>
					</div>
				</div> */}
					<Button type="filter" filterCount={props.filterCount || 0} clickHandler={props.flipShowFilters}>
						Filter
					</Button>
				</div>
				<div className="section-2">
					<SearchFilter
						filterOption={{ field: "searchFieldValue" }}
						value={props.searchFieldValue}
						setFilter={props.setFilter}
						placeholder="Search"
					/>
					<TableColumnSelector
						options={props.tableFields}
						handleColumnSelection={props.handleColumnSelection}
						selectedColumns={props.selectedColumns}
					/>
				</div>
			</div>
		</React.Fragment>
	);
};
